<template>
    <v-main v-resize="onResize">
        <v-data-table
                :headers="factoryHeaders"
                :items="factoryData"
                :search="searchText"
                sort-by="id"
                :items-per-page="itemsPerPageInt"
                class="elevation-3"
                dense
                locale="kr-KR"
                no-data-text="데이터가가 없습니다."
                no-results-text="검색 결과가 없습니다."
                :footer-props="{
                itemsPerPageText: '페이지당 거래처 수',
                itemsPerPageAllText: '전체',
                itemsPerPageAll: '전체',
                itemsPerPageOptions: [2, 10, 25, 50, 100, -1]
            }"
        >
            <template v-slot:top>
                <v-dialog v-model="dialog" max-width="500px">
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                        </v-card-title>

                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12">
                                        <v-select
                                                :items="factoryGroupList"
                                                label="분류 *"
                                                item-value="text"
                                                v-model="editedItem.group"
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field v-model="editedItem.name" label="거래처명"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field v-model="editedItem.phone" label="연락처"></v-text-field>
                                    </v-col>
                                    <v-textarea
                                            class="px-3 mb-n8"
                                            outlined
                                            label="비 고"
                                            v-model="editedItem.comment"
                                    ></v-textarea>
                                </v-row>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="save">저장</v-btn>
                            <v-btn color="blue darken-1" text @click="close">닫기</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-row class="mt-n16">
                    <v-col cols="12" sm="6" class="mb-n16">
                        <h2 class="ml-4 mb-7"><v-icon>mdi-cards-playing-outline</v-icon> 공장 목록</h2>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-card-title>
                            <v-text-field
                                    v-model="searchText"
                                    append-icon="mdi-magnify"
                                    label="검색"
                                    single-line
                                    hide-details
                            ></v-text-field>
                        </v-card-title>
                    </v-col>
                </v-row>
            </template>

            <template v-slot:item.actions="{ item }">
                <v-icon
                        small
                        class="mr-2"
                        @click="editItem(item)"
                >
                    mdi-pencil
                </v-icon>
                <v-icon
                        small
                        @click="deleteItem(item)"
                >
                    mdi-delete
                </v-icon>
            </template>
            <template v-slot:no-data>
            </template>
        </v-data-table>
    </v-main>
</template>

<script>
import axios from "axios";

export default {
    data: () => ({
        t: true,
        f: false,
        dialog: false,
        factoryHeaders: [
            { text: '고유번호', value: 'id' },
            { text: '분류', value: 'group' },
            { text: '거래처명', value: 'name' },
            { text: '연락처', value: 'phone' },
            { text: '작업', value: 'actions', sortable: false },
        ],
        factoryData: [],
        factoryGroupList: [],
        editedIndex: -1,
        editedItem: {
            id: '',
            group: '',
            name: '',
            phone: '',
            comment: '',
        },
        defaultItem: {
            id: '',
            group: '',
            name: '',
            phone: '',
            comment: '',
        },
        itemsPerPage: 25,
        searchText: '',
    }),

    computed: {
        itemsPerPageInt () {
            return parseInt(this.itemsPerPage)
        },
        formTitle () {
            return this.editedIndex === -1 ? '공장 등록' : '공장 수정'
        },
    },

    watch: {
        dialog (val) {
            val || this.close()
        },
    },

    created () {
        this.getFactories(),
            this.factoryGroupList = this.$store.getters.getFactoryGroupList
    },

    mounted() {
        this.onResize()
    },

    methods: {
        editItem (item) {
            this.editedIndex = this.factoryData.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialog = true
        },

        async deleteItem (item) {
            if(confirm('삭제 시 다시 되돌릴 수 없습니다.\n정말 삭제하시겠습니까?')) {
                if(await this.deleteFactory(item.id)) {
                    const index = this.factoryData.indexOf(item)
                    this.factoryData.splice(index, 1)
                }
            }
        },

        close () {
            this.dialog = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
        },

        save () {
            if (this.editedIndex > -1) {
                Object.assign(this.factoryData[this.editedIndex], this.editedItem)
            } else {
                this.factoryData.push(this.editedItem)
            }
            this.saveFactory()
            this.close()
        },

        getFactories: function() {

            return axios({
                method: 'GET',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                url: this.$store.getters.getApiUrl + '/api/v1/client/getClients/factory',
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
            .then(response => {

                if(response.data != null && !response.data.status != '9999'){

                    this.factoryData = response.data

                }else{

                    alert(response.data.message)
                    return false

                }

            })
            .catch((error) => {

                if(error && error.name == "InvalidJwtToken"){

                    //JWT 토큰이 정확하지 않을 시
                    alert('인증 토큰이 유효하지 않습니다.')
                    return false

                }else{

                    //저장 실패 시
                    alert('데이터 로딩에 실패했습니다.')

                }

            })

        },

        saveFactory: function() {

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                url: this.$store.getters.getApiUrl + '/api/v1/client/'+this.editedItem.id,
                data: this.editedItem,
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
            .then(response => {

                if(response.data != null && response.data.status != '9999'){

                    alert(response.data.message)
                    this.editedItem = this.defaultItem

                }else{

                    alert(response.data.message)
                    return false

                }

            })
            .catch((error) => {

                if(error && error.name == "InvalidJwtToken"){

                    //JWT 토큰이 정확하지 않을 시
                    alert('인증 토큰이 유효하지 않습니다.')
                    return false

                }else{

                    //저장 실패 시
                    alert('저장에 실패했습니다.\n다시 시도해주세요.')
                    return false

                }

            })

        },

        deleteFactory: function(id) {

            if(!id){
                alert('거래처 고유번호가 누락되었습니다\n개발자에게 문의하세요.')
                return false
            }

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                url: this.$store.getters.getApiUrl + '/api/v1/client/'+ id + '?_method=delete',
                data: {
                    type: 'factory',
                    clientId: id
                },
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
            .then(response => {

                if(response.data != null && response.data.status == '0000'){

                    alert(response.data.message)
                    return true

                }else{

                    alert(response.data.message)
                    return false

                }

            })
            .catch((error) => {

                if(error && error.name == "InvalidJwtToken"){

                    //JWT 토큰이 정확하지 않을 시
                    alert('인증 토큰이 유효하지 않습니다.')
                    return false

                }else{

                    //삭제 실패 시
                    alert('삭제에 실패했습니다.\n다시 시도해주세요.')
                    return false

                }

            })

        },

        onResize: function() {

            switch(this.$vuetify.breakpoint.name) {
                case 'xs':
                    this.itemsPerPage = '2'
                    break
                case 'sm':
                    this.itemsPerPage = '10'
                    break
                case 'md':
                case 'lg':
                case 'xl':
                    this.itemsPerPage = '25'
                    break
                default:
                    this.itemsPerPage = '25'
            }

        }

    }
}
</script>